import { useSelector } from 'react-redux';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from './ContactUsCallUsSection.module.scss';
import { CatTextLink } from '@blocks-react/components/TextLink';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { useTranslation } from 'react-i18next';
import { replaceTokensInString } from '@app/utils';
import cx from 'classnames';
import { STATIC_PHONE_NUMBER } from '../constants';

const ContactUsCallUsSection = () => {
  const { t } = useTranslation();
  const isCatCorp = useSelector(s => s.common?.isCatCorp) || false;
  const helpCenterEnabled =
    useSelector(state => state.featureFlag?.PCCCustomerSupportHelpCenter) ||
    false;
  const dynamicPhoneNumber = useSelector(s => s.store?.phone);
  const phoneNumber =
    !isCatCorp && !helpCenterEnabled ? dynamicPhoneNumber : STATIC_PHONE_NUMBER;
  const callUsMesssage = replaceTokensInString(
    t('CALL_US_DETAILS'),
    phoneNumber
  );

  if (!phoneNumber) {
    return null;
  }

  return (
    <div
      className={cx(styles['contactUsPage__callUsSection'], 'cat-u-hide-md')}
    >
      <CatTextPassage size="sm">
        <CatHeading level="h4" variant="title">
          {t('CALL_A_CAT_PARTS_EXPERT')}
        </CatHeading>
        <p className={cx('my-1', styles['contactUsPage__callUsSection__text'])}>
          {callUsMesssage}
        </p>
      </CatTextPassage>
      <div className={styles['contactUsPage__callUsSection__action-button']}>
        <CatTextLink href={`tel:${phoneNumber}`} size="sm">
          {t('CALL_TOLL_FREE')}
        </CatTextLink>
      </div>
    </div>
  );
};

export default ContactUsCallUsSection;
